window.$ = window.jQuery = require('jquery');

require ('bootstrap');

require('jquery-ui');

import swal from 'sweetalert2';
window.swal = swal;

require('@popperjs/core');

require('sparkline');

window.toastr = require('toastr');

require('summernote');
require('summernote/dist/lang/summernote-fr-FR.min');

require('bootstrap-fileinput');
require('bootstrap-fileinput/themes/fas/theme');
require('bootstrap-fileinput/js/locales/fr.js');

require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js');

// Datatable
require('datatables.net');
require('datatables.net-bs5');
require('datatables.net-buttons');
require('datatables.net-buttons-bs5');
require('datatables.net-fixedheader');
require('datatables.net-fixedheader-bs5');
require('datatables.net-rowreorder');
require('datatables.net-rowreorder-bs5');
require('datatables.net-responsive');
require('datatables.net-responsive-bs5');

import validate from 'jquery-validation';
import 'jquery-validation/dist/localization/messages_fr.js';
import 'select2';

//Éviter tant que possible de charger les dépendances de cette manière, préférez l'utilisation de npm.
require('./hegyd/librairies/jquery.bootstrap-touchspin.js');
require('./hegyd/librairies/jquery.multi-select.js');
require('./hegyd/librairies/modernizr-object-fit.js');
require('./hegyd/librairies/perfect-scrollbar.jquery.min.js');

require('hegyd/core/resources/assets/js/hegyd-core.js');
require('hegyd/core/resources/assets/dependencies/jquery-form/jquery.form.js');

require('hegyd/core/resources/assets/js/notifications.js');

require('hegyd/core/resources/assets/js/datatable/datatable.js');
require('hegyd/core/resources/assets/js/datatable/bulk_actions.js');
require('hegyd/core/resources/assets/js/datatable/default.js');

require('./../../../../../vendor/hegyd/products/resources/assets/js/main-bo.js');

require('hegyd/core/resources/assets/js/main.js');
require('hegyd/ecommerce-v2/resources/assets/tabler/js/backoffice/main.js');
require('hegyd/slides/resources/assets/js/main-bo.js');
require('hegyd/email-template/resources/assets/js/main.js');
require('hegyd/eav/resources/assets/js/main.js');
require('hegyd/modal-information/resources/assets/js/admin/main.js');

import BcpModal from './pages/users/commercial/bcp';
customElements.define('bcp-modal', BcpModal,{extends: 'a'});

import ContactsModal from './pages/contacts/contacts';
customElements.define('contacts-modal', ContactsModal,{extends: 'a'});

import PromotionDuplicate from './pages/ecommerce/promotions';
customElements.define('promotion-duplicate', PromotionDuplicate,{extends: 'a'});

import BcpChangeYears from './pages/bcp-promotions/index-bcp-years';
customElements.define('bcp-change-years', BcpChangeYears,{extends: 'select'});

import BcpImportBtn from './pages/bcp-promotions/index-bcp-import-btn';
customElements.define('bcp-import-btn', BcpImportBtn,{extends: 'a'});

import TarifEcommerceImport from './pages/ecommerce/tarif_ecommerce_import';
customElements.define('ecommerce-import-btn', TarifEcommerceImport,{extends: 'a'});

import PromoImportBtn from '../../vendor/hegyd/ecommerce/js/pages/promotions/index-promo-import-btn';
customElements.define('promo-import-btn', PromoImportBtn,{extends: 'a'});

import ProductAdder from './retail/product-adder';
customElements.define('product-adder', ProductAdder, {extends:'div'});

import AdvancedDatePicker from './components/AdvancedDatePicker';
customElements.define('advanced-date-picker', AdvancedDatePicker, {extends:'div'});

import AnotherDoc from './components/anotherDoc';
customElements.define('another-doc', AnotherDoc,{extends: 'div'});

import ConfirmUnlock from './components/confirm-unlock';
customElements.define('confirm-unlock', ConfirmUnlock,{extends: 'a'});

import GenerateBcpCode from './components/GenerateBcpCode';
customElements.define('generate-bcp-code', GenerateBcpCode,{extends: 'div'});

import CguProductsList from './components/CguProductsList';
customElements.define('cgu-products-list', CguProductsList, {extends: 'div'});
